export default __webpack_public_path__ + "static/media/chatImage.a26de27a.png";